import { Component, OnInit } from '@angular/core';
import { RutasService } from '../../services/rutas.service';
import { ActivatedRoute, Params, Router  } from '@angular/router';
// Servicios
import { MapService } from '../../services/map.service';
import { PrestamosService } from '../../services/prestamos.service';
import { EmpleadosServicio } from '../../services/empleado.service';
import { Socket } from 'ng-socket-io';
import { Helper } from '../../helpers/helper';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

const ID_PAGINA = 1;

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styles: [
    `.d-flex{
      display: flex;
    }
    .jc-space-between{
      justify-content: space-between;
    }`
  ]
})
export class InicioComponent implements OnInit {
  zoom = 8;
  lat = 18.848449;
  lng = -70.9046499;
  mapaElems = 'todos';
  dropdownMap = -1;
  markers = [];
  cobrosExtraordinarios = 0;
  proyeccion = 0;
  gastoCierrePN = 0;
  gastoCierreRN = 0;
  prestamosNuevos = 0;
  prestamosRenovados = 0;
  pagosAlDia = 0;
  pagosAtrasos = 0;
  moraAtrasos = 0;
  pagosVencidos = 0;
  moraVencidos = 0;
  pagos = 0;
  pagosTotal = 0;
  gastosDietas = 0;
  rutas = [];
  ruteros = [];
  ruteroSeleccionado = '';
  fecha: NgbDateStruct;
  now = new Date(this.helper.getDate());
  urlImg;
  loading = false;
  markersEmpleados = [];
  empleadoLat = 0;
  empleadoLng = 0;
  mapTypeId = 'roadmap';
  fechaFormat = '';
  screenLarge = true;
  dropdownSettings: any;
  rutasSeleccionadas = [];
  aplicarFiltrosMapa = false;
  rutasSeleccionadasAntes = false

  constructor(private mapService: MapService,
    private prestamoService: PrestamosService,
    private socket: Socket,
    private rutaService: RutasService,
    private route: ActivatedRoute,
    public empleadoService: EmpleadosServicio,
    private router: Router,
    private helper: Helper) {

    if (empleadoService.datosEmpleado.tipo_empleado !== 3 && !empleadoService.paginasAsignadas.filter(page => page.ID_PAGINA == ID_PAGINA).length) {
      this.router.navigate(['/404']);
    }

    // Inicializar prestamosNuevos
    this.initRutas();
    this.initRuteros();
    this.urlImg = this.helper.urlImg + 'cedulas/';
    this.fecha = {
      day: this.now.getDate(),
      month: this.now.getMonth() + 1,
      year: this.now.getFullYear()
    };

    /*if ( localStorage.getItem('rutasSeleccionadas')) {
      this.rutasSeleccionadas = JSON.parse(localStorage.getItem('rutasSeleccionadas'));
    }*/

    this.rutasSeleccionadas = rutaService.getSelectedRoutes();
    if (this.rutasSeleccionadas.length > 0) {
      this.rutasSeleccionadasAntes = true;
    }

    this.screenLarge = !window.matchMedia('(min-width: 1200px)').matches;
    window.onresize = () => this.screenLarge = !window.matchMedia('(min-width: 1200px)').matches;
  }

  ngOnInit() {
    this.initConfigMultiSelect();
    this.verificarQueryString();
    this.initTableroSocket();
    this.initMapaSocket();

    if (localStorage.getItem('mapType')) {
      this.mapTypeId = (localStorage.getItem('mapType') === 'hybrid' ? 'hybrid' : 'roadmap');
    }
  }

  private verificarQueryString(): void {
    this.route.queryParams.subscribe(params => {
      if (params) {

        if (params.fecha) {

          const year = parseFloat(params.fecha.split('-')[0]);
          const month = parseFloat(params.fecha.split('-')[1]);
          const day = parseFloat(params.fecha.split('-')[2]);
          if (!isNaN( year ) && !isNaN( month ) && !isNaN( day )) {
            this.fecha.year = year;
            this.fecha.month = month;
            this.fecha.day = day;
          } else {
            this.fecha = {
              day: this.now.getDate(),
              month: this.now.getMonth() + 1,
              year: this.now.getFullYear()
            };
          }
        }

        if (params.mapa) {
          switch (params.mapa) {
            case 'clientes':
            case 'cliente':
            this.dropdownMap = 1; this.mapaElems = 'clientes'; break;

            case 'notas':
            case 'nota':
            this.dropdownMap = 2; this.mapaElems = 'notas'; break;

            case 'pagos':
            case 'pago':
            this.dropdownMap = 3; this.mapaElems = 'pagos'; break;

            case 'prestamos':
            case 'prestamo':
            this.dropdownMap = 4; this.mapaElems = 'prestamos'; break;

            case 'empleados':
            case 'empleado':
            this.dropdownMap = 5; this.mapaElems = 'empleados'; break;

            default: this.dropdownMap = -1; this.mapaElems = 'todos'; break;
          }
        }

        if (params.rutas) {
          this.rutasSeleccionadas = [];
          for (const ruta of this.rutas) {
            for (const rutaSeleccionada of params.rutas.split(',')) {
              if (parseFloat(rutaSeleccionada) === ruta.id) {
                this.rutasSeleccionadas.push(ruta);
              }
            }
          }
          if (this.rutas.length > 0) {
            this.rutaService.setSelectedRoutes(this.rutasSeleccionadas);
          }
        }
        if  (this.rutasSeleccionadas.length > 0)  {

          this.rutaService.setSelectedRoutes(this.rutasSeleccionadas);
          this.rutasSeleccionadasAntes = false;
        } else {
          if  (this.rutasSeleccionadasAntes) {
            this.rutasSeleccionadas = this.rutaService.getSelectedRoutes();
            this.rutasSeleccionadasAntes = false;
          } else  {
            this.rutaService.removeSelectedRoutes();
          }

        }
        this.initTablero();
        this.initMapa();
      }
    });
  }

  private initTableroSocket(): void {
    const tipo_empleado =  this.empleadoService.datosEmpleado.tipo_empleado;
    this.socket.on('tableroPrestamo', (data) => {
      if (parseFloat(data.compania) === this.helper.compania) {
        switch (data.estado) {
          case 1:
          if (this.rutasSeleccionadas.includes(data.ID_RUTA) || tipo_empleado === 3) {

            if (data.renovacion === 1) { // Sumar capital a renovaciones
              this.prestamosRenovados += parseFloat(data.capital);
            } else { // Sumar capital a prestamos nuevos
              this.prestamosNuevos += parseFloat(data.capital);
            }
          }
          break;
        }
      }
    });

    this.socket.on('tableroPago', data => {
      if (parseFloat(data.compania) === this.helper.compania) {

        // Sumar pagos al día
        if (
          this.rutasSeleccionadas.includes(data.ID_RUTA) || tipo_empleado === 3 &&
          data.cuota.fecha_vence.split('T')[0] >= data.fecha_pago.split('T')[0]
        ) {
          this.pagosAlDia += data.monto_pagado;
        }

        // Sumar pagos atrasados
        if (
          this.rutasSeleccionadas.includes(data.ID_RUTA) || tipo_empleado === 3 &&
          data.fecha_pago.split('T')[0] > data.cuota.fecha_vence.split('T')[0] &&
          data.fecha_vence.split('T')[0] >=  data.fecha_pago.split('T')[0]
        ) {
          this.pagosAtrasos += data.monto_pagado;
          this.moraAtrasos += data.mora;
        }

        // Sumar pagos vencidos
        if (
          this.rutasSeleccionadas.includes(data.ID_RUTA) || tipo_empleado === 3 &&
          data.fecha_vence.split('T')[0] < data.fecha_pago.split('T')[0]
        ) {
          this.pagosVencidos += data.monto_pagado;
          this.moraVencidos += data.mora;
        }
      }
    });
  }

  private initRutas(): void {
    this.rutaService.cargarTodasLasRutas().subscribe(res => {
      for (const ruta of res.rutas) {
        this.rutas.push({
          id: ruta.ID_RUTA,
          itemName: String(ruta.nombre)
        });
      }
    });
  }

  get rutasSelected() {
    return this.rutasSeleccionadas.map(data => data.id).join();
  }

  private initTablero(): void {

    if (this.fecha !== undefined && this.fecha !== null && this.fecha.year !== null) {
      this.fechaFormat = `${this.fecha.year}-${this.fecha.month}-${this.fecha.day}`;
    }

    // Prestamos nuevos
    this.prestamoService.obtenerTableroPrestamo(
      '1',
      this.rutasSelected,
      this.fechaFormat
    ).subscribe((res: any) => {
      if (res) {
        this.prestamosNuevos = res.prestamos;
        this.gastoCierrePN = res.gasto_cierre;
      }
    });

    // Renovaciones
    this.prestamoService.obtenerTableroPrestamo(
      '1',
      this.rutasSelected,
      this.fechaFormat,
      '1'
    ).subscribe((res: any) => {
      if (res) {
        this.prestamosRenovados = res.prestamos;
        this.gastoCierreRN = res.gasto_cierre;
      }
    });

    // Cobros extraordinarios
    this.prestamoService.obtenerTableroExtraordinario(
      this.rutasSelected,
      this.fechaFormat
    ).subscribe((res: any) => this.cobrosExtraordinarios = res);

    // Pagos al dia
    this.prestamoService.obtenerTableroPagosAlDia(
      this.rutasSelected,
      this.fechaFormat
    ).subscribe((res: any) => this.pagosAlDia = res);

    // Pagos con atrasos
    this.prestamoService.obtenerTableroPagosAtrasos(
      this.rutasSelected,
      this.fechaFormat
    ).subscribe((res: any) => { this.pagosAtrasos = res.pagos; this.moraAtrasos = res.mora; });

    // Pagos vencidos
    this.prestamoService.obtenerTableroPagosVencidos(
      this.rutasSelected,
      this.fechaFormat
    ).subscribe((res: any) => { this.pagosVencidos = res.pagos; this.moraVencidos = res.mora; });

    // Proyeccion, Pagos
    this.prestamoService.obtenerTableroPagos(
      this.rutasSelected,
      this.fechaFormat
    ).subscribe((res: any) => {
      this.pagos = res.pagos;
      this.pagosTotal = res.total;
      this.proyeccion = res.proyeccion || 0;
    });
  }

  filtrarTablero() {
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    queryParams['fecha'] = `${this.fecha.year}-${this.fecha.month}-${this.fecha.day}`;

    const rutas = this.rutasSeleccionadas.map(data => data.id).join();
    if (rutas) {
      localStorage.setItem('rutasSeleccionadas', JSON.stringify(this.rutasSeleccionadas));
      queryParams['rutas'] = rutas;
    } else {
      delete queryParams['rutas'];
      localStorage.removeItem('rutasSeleccionadas');
    }

    this.router.navigate(['.'], { queryParams: queryParams });
  }

  initMapa() {
    this.markers = [];

    if (this.aplicarFiltrosMapa) {
      this.loading = true;

      if (this.fecha.year) {
        this.fechaFormat = `${this.fecha.year}-${this.fecha.month}-${this.fecha.day}`;
      }

      this.mapService.tableroMapa(
        String(this.dropdownMap),
        this.rutasSelected,
        this.fechaFormat
      ).subscribe((res: any) => {
        this.markers = [...this.markers, ...res.clientes];
        this.markers = [...this.markers, ...res.notas];
        this.markers = [...this.markers, ...res.pagos];
        this.markers = [...this.markers, ...res.prestamos];
        setTimeout(() => this.loading = false, 1);
      }, () => setTimeout(() => this.loading = false, 1));
    }
  }

  filtrarMapa() {
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    switch (this.dropdownMap) {
      case 1: queryParams['mapa'] = this.mapaElems = 'clientes'; break;
      case 2: queryParams['mapa'] = this.mapaElems = 'notas'; break;
      case 3: queryParams['mapa'] = this.mapaElems = 'pagos'; break;
      case 4: queryParams['mapa'] = this.mapaElems = 'prestamos'; break;
      case 5: queryParams['mapa'] = this.mapaElems = 'empleados'; break;
      default: queryParams['mapa'] = this.mapaElems = 'todos'; break;
    }
    this.router.navigate(['.'], { queryParams: queryParams });

    if (this.dropdownMap === -1 || this.dropdownMap === 5) {
      this.initRuteros();
    } else {
      this.markersEmpleados = [];
    }
  }

  private initMapaSocket(): void {
    this.socket.on('tableroMapa', (marker) => {
      if (parseFloat(marker.compania) === this.helper.compania) {
        if (marker.tipo == 1) {
          for (const m of this.markersEmpleados) {
            if (m.ID_EMPLEADO === marker.ID_EMPLEADO) {
              m.lat = marker.lat;
              m.lng = marker.lng;
              m.velocidad = marker.velocidad;
              if (this.ruteroSeleccionado !== '' && m.ID_EMPLEADO === parseFloat(this.ruteroSeleccionado)) {
                this.lat = marker.lat;
                this.lng = marker.lng;
                this.zoom = 17;
              }
            }
          }
        } else if ([2,3,4,5].includes(marker.tipo) && this.rutasSeleccionadas.includes(marker.ID_RUTA)) {
          this.markers.push(marker);
        }
      }
    });
  }

  private initRuteros(): void {
    this.empleadoService.ruterosMapa().subscribe((res: any) => this.markersEmpleados = res);
  }

  seguirA() {
    if (this.ruteroSeleccionado !== '' && parseFloat(this.ruteroSeleccionado) > 0) {
      for (const rutero of this.markersEmpleados) {
        if (rutero.ID_EMPLEADO === parseFloat(this.ruteroSeleccionado)) {
          this.lat = rutero.lat;
          this.lng = rutero.lng;
          this.zoom = 17;
        }
      }
    }
  }

  private initConfigMultiSelect() {
    this.dropdownSettings = {
      singleSelection: false,
      text: 'Seleccionar zona',
      selectAllText: 'Seleccionar todo',
      unSelectAllText: 'Deseleccionar todo',
      enableSearchFilter: true,
      classes: 'custom-multiselect',
      badgeShowLimit: 1,
      searchPlaceholderText: 'Búsqueda'
    };
  }

  tipoMap(map: string): void {
    this.mapTypeId = map;
    localStorage.setItem('mapType', map);
  }

  trackByFn(index, item) {
    return index; // or item.id
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/inicio/inicio.component.ts